<template>
    <div class="row justify-content-center">
        <div v-if="profile" class="form-container d-flex flex-column align-items-center">
            <h2 class="title-text mx-auto">
                {{ $t('title.editMail') }}
            </h2>

            <ValidationObserver ref="mailObserver">
                <form id="changeMail">
                    <v-input
                        v-model="mail"
                        class="input-w-default mb-0 mt-2"
                        ind="0"
                        type="text"
                        :placeholder="$t('placeholder.email')"
                        :icon="$getInputIcon(mail, 'email')"
                        :debounce="500"
                        rules="required|email|emailNotExists"
                    />
                </form>

                <b-button class="center-element change-button" @click="changeMail">
                    {{ $t('button.save') }}
                </b-button>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
    import VInput from './VInput';
    import { USER_UPDATE_MAIL } from 'actions/user';
    import { mapGetters } from 'vuex';

    export default {
        name: 'ChangeMail',

        components: {
            VInput
        },

        computed: {
            ...mapGetters('user', [ 'profile' ])
        },

        data() {
            return {
                mail: ''
            };
        },

        methods: {
            async changeMail() {
                let isValid = await this.$refs.mailObserver.validate();

                if (!isValid)
                    return;

                try {
                    let response = await this.$store.dispatch(`user/${USER_UPDATE_MAIL}`, this.mail);

                    if (response && response.status === this.$defines.RESPONSE_STATUS.OK)
                        this.$toast.success(this.mail, this.$t('message.confirmLetterForEmailChangeSent'), { position: 'topRight' });
                }
                catch (error) {
                    this.$toast.error(this.$t('message.mailChangeFailed'), '', { position: 'topRight' });
                }
            }
        }
    };
</script>

<style scoped>
    .title-text {
        font-weight: lighter !important;
        font-size: 23px;
        line-height: 27px;
        text-decoration: none !important;
        padding-bottom: 2px;
        border-bottom: 1px solid #FFFFFF;
        color: white;
        text-align: center;
        text-decoration-skip-ink: none;
        width: 50%;
    }

    .center-element {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
    }

    .change-button {
        align-items: center;
        margin-top: 3rem;
        background-color: transparent;
        border: 1px solid #338DC9;
        border-radius: 5px;
        width: 50%;
        margin-bottom: 1rem;
    }

    .change-button:hover {
        background-color: #338DC9 !important;
    }
</style>